<template>
    <o-dropdown aria-role="list" v-if="currentUser" class="user-menu-dropdown is-pulled-right" position="bottom-left">
      <template #trigger="{ active }">
        <a class="navbar-item between-center">
          <figure class="avatar">
            <img class="avatar" :src="currentUser.avatar_url" alt="Avatar" width="47" height="47">
          </figure>
          <clock-buttons />
          <span class="is-hidden-mobile">{{ userNameById(currentUserId) }}</span>
          <o-icon pack="fa" icon="angle-down"></o-icon>
        </a>
      </template>
        <o-dropdown-item  aria-role="listitem">
            <router-link :to="{ name: 'dashboard' }">
                Home
            </router-link>
        </o-dropdown-item>
        <hr class="dropdown-divider">
        <o-dropdown-item  aria-role="listitem">
            <router-link :to="{ name: 'user-settings' }">
                Settings
            </router-link>
        </o-dropdown-item>
        <o-dropdown-item  v-if="isCurrentUserAdmin" aria-role="listitem">
            <router-link :to="{ name: 'emails-' }">
                Emails
            </router-link>
        </o-dropdown-item>
        <o-dropdown-item  aria-role="listitem">
            <a href="#" @click.prevent="userLogout">Logout</a>
        </o-dropdown-item>
    </o-dropdown>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import ClockButtons from './timelog/ClockButtons.vue'

    export default {
        components: { ClockButtons, },
        computed: {
            ...mapGetters(['userNameById', 'currentUserId', 'currentUser', 'isCurrentUserAdmin'])
        },

        methods: {
            ...mapActions(['userLogout'])
        }
    }
</script>

<style>
.user-menu-dropdown .dropdown-menu {
  width: 100%; }

</style>